import React, { Component } from 'react';
import { Card, Row, Col, Table, Button, Input, ButtonGroup, Alert as Alert2 } from "reactstrap";
import { api, filterHelper } from "../helpers";
import { TextFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const emptyProductionPlanCategory = {
  id: '',
  name: '',
  displayOrder: null,
}

export default class ProductionPlanCategory extends Component {
  static displayName = ProductionPlanCategory.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      editProductionPlanCategory: null,
      filters: [],
      pagedList: null,
      sortColumn: "Id",
      sortAscending: true,

    }
    this.addProductionPlanCategory = this.addProductionPlanCategory.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);

  }

  componentDidMount() {
      this.onChangeFilter({
        filterName: "activeOnly",
        value: true,
        filteredDisplay: "Active Only"
      });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/ProductionPlanCategories", payload)
      .then(response => {
        if (response && response.data) {
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: response.data.dataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            editProductionPlanCategory: null,
            message: null,
            messageColor: null,
            isMessageVisible: false,
          });
        }
      })
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  addProductionPlanCategory() {
    this.setState({
      editProductionPlanCategory: emptyProductionPlanCategory
    })
  }

  onInputChange(e, fieldName) {
    this.setState({
      editProductionPlanCategory: { ...this.state.editProductionPlanCategory, [fieldName]: e.target.value }
    })
  }

  onCancel() {
    this.setState({
      editProductionPlanCategory: null
    });
  }

  onSave() {
    let category = Object.assign({}, this.state.editProductionPlanCategory);
    if (category.name === "" ) {
      this.setState({ message: "Please enter a Category Name.", messageColor: "danger" });
      return;
    }
    if (category.displayOrder === null) {
      this.setState({ message: "Display Order is required.", messageColor: "danger" });
      return;
    }
    let payload = {
      Name: category.name,
      DisplayOrder: parseInt(category.displayOrder, 10)
    }
    if (category.id) {
      payload.Id = category.id;
    }

    api.post("Admin/SaveProductionPlanCategory", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success("Production Plan Category was created.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Production Plan Category cannot be created at this time.")
        }
      }).catch(error => Alert.error("There was an error creating the Production Plan Category."));
  }

  onEdit(ProductionPlanCategoryId) {
    let list = this.state.pagedList.list.slice();
    let category = _.find(list, g => {
      return g.id === ProductionPlanCategoryId
    });
    this.setState({
      editProductionPlanCategory: category
    });
    window.scrollTo(0, 0);
  }

  onDelete(ProductionPlanCategoryId) {
    if (!window.confirm(`Are you sure you'd like to delete this Production Plan Category?`)) return;

    api.delete(`Admin/DeleteProductionPlanCategory/${ProductionPlanCategoryId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Production Plan Category was deleted.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Production Plan Category cannot be deleted at this time.")
        }
      }).catch(error => {
        Alert.error("There was an error deleting the Production Plan Category.")
      });
  }

  onRevive(ProductionPlanCategoryId) {
    api.post("Admin/ReviveProductionPlanCategory", ProductionPlanCategoryId)
      .then(response => {
        if (response.data.success) {
          Alert.success("Production Plan Category was revived.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Production Plan Category cannot be revived at this time.")
        }
      }).catch(error => Alert.error("There was an error reviving the Production Plan Category."));
  }

  render() {
    let editProductionPlanCategory = this.state.editProductionPlanCategory;
    return (
      <div>
        <Row>
          <Col><h5>Production Plan Category</h5></Col>
          <Col className="mr-3">
            {this.state.editProductionPlanCategory ? null : (
              <Button size="sm" color="success" className="float-right" onClick={this.addProductionPlanCategory}>Add New Category</Button>
            )}
          </Col>
        </Row>

        {this.state.message ? (
          <Alert2 color={this.state.messageColor} toggle={()=>this.onDismiss()}>{this.state.message}</Alert2>
        ) : null}

        {this.state.editProductionPlanCategory ? (
          <Card className="p-2">
            <Row>
              <Col>Name: <Input type="text" maxLength="60" name="name" id="name" onChange={(e) => this.onInputChange(e, "name")} value={editProductionPlanCategory.name} /></Col>
              <Col>Display Order: <Input type="text" name="displayOrder" id="displayOrder" onChange={(e) => this.onInputChange(e, "displayOrder")} value={editProductionPlanCategory.displayOrder} /></Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button size="sm" color="secondary" className="buttonGroupSpacing"  onClick={this.onCancel}>Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onSave()}>{editProductionPlanCategory.id ? ("Update") : ("Save")}</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        ) : null}

        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
              <Col xs="3">
                <TextFilter
                  filterName="name"
                  displayName="Production Plan Category Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Display Order</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(category => (
                    <tr key={`pg-${category.id}`}>
                      <td>{category.name}</td>
                      <td>{category.displayOrder}</td>
                      <td>
                        <ButtonGroup className="float-right">
                          {category.deactivatedAt === null ? (
                            <React.Fragment>
                              <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onEdit(category.id)} disabled={this.state.editProductionPlanCategory !== null} title="Edit">
                                <FontAwesomeIcon
                                  icon="edit"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer"
                                  title="Edit"
                                />

                              </Button>
                              <Button size="sm" className="cbdmdDanger buttonGroupSpacing" onClick={() => this.onDelete(category.id)} disabled={this.state.editProductionPlanCategory !== null} title="Delete">
                                <FontAwesomeIcon
                                  icon="trash-alt"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer "
                                  title="Delete"
                                />
                              </Button>
                            </React.Fragment>
                          ) : (
                              <Button size="sm" className="cbdmdInfoTeal" onClick={() => this.onRevive(category.id)} disabled={this.state.editProductionPlanCategory !== null}>Revive</Button>
                            )}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                ) : (
                    <tr>
                      <td>
                        No Records available
                    </td>
                    </tr>
                  )}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />

          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductionPlanCategory.js